module.exports = __webpack_public_path__ + "img/AT0000000537595.d20d8861.png";